import React from 'react';
import { CardTitleStyle } from '../style'

export default function CardTitle({ children, ...options }) {
    return (
        <CardTitleStyle {...options}>
            {children}
        </CardTitleStyle>
    )
}